import { render } from "./GMVChart.vue?vue&type=template&id=6bedef6c&scoped=true"
import script from "./GMVChart.vue?vue&type=script&lang=js"
export * from "./GMVChart.vue?vue&type=script&lang=js"

import "./GMVChart.vue?vue&type=style&index=0&id=6bedef6c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bedef6c"]])

export default __exports__